import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import TiptapEditor from '~/javascript/components/admin/blog/TiptapEditor.vue'

/**
 * Customer-side blog post editor.
 *
 * Mounts the same TipTap Vue component the admin side uses, but
 * scoped to the customer dashboard route so it stays available
 * outside admin pages.
 *
 * Usage:
 *   <div data-controller="blog-post-editor"
 *        data-blog-post-editor-content-value='{"type":"doc","content":[]}'
 *        data-blog-post-editor-field-id-value="blog-post-body">
 *   </div>
 *   <input type="hidden" id="blog-post-body" name="blog_post[body]">
 */
export default class extends Controller {
  static values = {
    content: { type: String, default: '' },
    fieldId: { type: String, default: 'blog-post-body' },
    placeholder: { type: String, default: 'Start writing your blog post...' }
  }

  connect() { this.mountVueComponent() }

  disconnect() { this.unmountVueComponent() }

  mountVueComponent() {
    const fieldId = this.fieldIdValue
    const initialContent = this.contentValue
    const placeholder = this.placeholderValue

    this.vueApp = createApp(TiptapEditor, {
      modelValue: initialContent,
      placeholder,
      'onUpdate:modelValue': (value) => {
        const hiddenField = document.getElementById(fieldId)
        if (hiddenField) hiddenField.value = value
      }
    })

    this.vueApp.mount(this.element)

    if (initialContent) {
      const hiddenField = document.getElementById(fieldId)
      if (hiddenField) hiddenField.value = initialContent
    }
  }

  unmountVueComponent() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }

  contentValueChanged() {
    if (this.vueApp) {
      this.unmountVueComponent()
      this.mountVueComponent()
    }
  }
}
